import { render, staticRenderFns } from "./TefConfigTerminales.vue?vue&type=template&id=50520a32"
import script from "./TefConfigTerminales.vue?vue&type=script&lang=js"
export * from "./TefConfigTerminales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50520a32')) {
      api.createRecord('50520a32', component.options)
    } else {
      api.reload('50520a32', component.options)
    }
    module.hot.accept("./TefConfigTerminales.vue?vue&type=template&id=50520a32", function () {
      api.rerender('50520a32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/tef/TefConfigTerminales.vue"
export default component.exports